/**
 * Landing pages data — copywriting persuasivo, moduli, FAQ specifiche per ogni corso.
 * Ogni voce mappa una route `/landing-corso-{slug}` a un corso principale sul sito.
 */

export const LANDINGS = {
  // ============================================================
  // 1. CONTROLLA LA TUA COMUNICAZIONE DIGITALE (CQO)
  // ============================================================
  cqo: {
    slug: "cqo",
    courseSlug: "controlla-la-tua-comunicazione-digitale",
    courseName: "Controlla la tua Comunicazione Digitale",
    price: 260,
    originalPrice: 520,
    hours: "9 ore in aula",
    heroImage: "/location/exterior.jpg",
    heroLabel: "Corso in presenza · Pisa",

    // HERO
    hookHeadline: "Basta improvvisare online.",
    hookHeadlineAccent: "Prendi il controllo.",
    hookSubtitle:
      "Il metodo pratico per progettare, gestire e monitorare la tua presenza digitale come un vero direttore d'orchestra — senza dipendere da agenzie o freelance.",
    ctaPrimary: "Scopri il corso",
    ctaSecondary: "Sconto esclusivo dal 50%",

    // A/B TEST — variante B (viene mostrata al 50% dei visitatori, sticky per browser)
    variantB: {
      hookHeadline: "Il tuo digitale non lavora per te?",
      hookHeadlineAccent: "Rimetti tu le regole.",
      ctaPrimary: "Scopri il corso",
    },

    // PROBLEMA
    painsTitle: "Ti riconosci in questo?",
    pains: [
      "Hai un sito, i social attivi, forse anche qualche campagna — ma nessun quadro chiaro di cosa funziona e cosa no.",
      "Ogni fornitore ti parla una lingua diversa e nessuno ti spiega il quadro d'insieme.",
      "Paghi ogni mese qualcuno per gestire la tua comunicazione, ma non sai valutare se sta lavorando bene.",
    ],

    // SOLUZIONE
    solutionTitle: "Il metodo My Digital Action per il tuo Digital Ecosystem",
    solutionText:
      "Un percorso in aula di 9 ore che ti insegna a leggere, progettare e controllare tutti i canali digitali della tua attività: sito, social, ads, email, funnel. Alla fine, hai la mappa completa del tuo ecosistema e sai esattamente cosa chiedere ai fornitori e cosa ottenere.",

    // COSA IMPARERAI
    learnTitle: "Cosa imparerai in aula",
    learnItems: [
      "Progettare l'ecosistema digitale della tua attività (framework MDA)",
      "Leggere e interpretare i KPI dei tuoi canali (traffico, engagement, conversioni)",
      "Costruire una comunicazione coerente su tutti i touchpoint del cliente",
      "Analizzare la concorrenza digitale e trovare il tuo posizionamento",
      "Impostare un piano editoriale che funziona anche senza esperto interno",
      "Valutare oggettivamente i fornitori (web agency, social manager, media buyer)",
      "Sistema di controllo mensile per non perdere mai il polso della tua presenza online",
    ],

    // TARGET
    targetTitle: "A chi è dedicato",
    targetItems: [
      "Imprenditori e liberi professionisti che vogliono capire davvero cosa sta succedendo online",
      "Chi ha già investito in marketing ma non ha ottenuto risultati chiari",
      "Manager che devono coordinare consulenti esterni senza esserne dipendenti",
    ],

    // FAQ
    faqs: [
      { q: "Devo avere conoscenze tecniche?", a: "Assolutamente no. Il corso è pensato per imprenditori e professionisti senza background tecnico. Linguaggio chiaro, esempi concreti." },
      { q: "Il corso è solo teorico?", a: "No. Lavoreremo sulla TUA attività reale con case study, template e workbook che porti a casa." },
      { q: "Dove si svolge?", a: "In presenza al Campus Montacchiello di Pisa. Pausa pranzo conviviale inclusa." },
      { q: "C'è una garanzia?", a: "Sì. Soddisfatti o rimborsati fino alle 13:00 del giorno del corso. Ti restituiamo tutto e tieni il workbook come nostro omaggio." },
      { q: "Come funziona il pagamento?", a: "Carta o PayPal. Anche in 3 rate senza interessi con PayPal." },
    ],
  },

  // ============================================================
  // 2. SOCIAL MEDIA MARKETING (SMM)
  // ============================================================
  smm: {
    slug: "smm",
    courseSlug: "social-media-marketing",
    courseName: "Social Media Marketing spiegato semplice",
    price: 260,
    originalPrice: 520,
    hours: "9 ore in aula",
    heroImage: "/location/interior-2.webp",
    heroLabel: "Corso in presenza · Pisa",

    hookHeadline: "Fai social media che vendono.",
    hookHeadlineAccent: "Non solo che piacciono.",
    hookSubtitle:
      "In 9 ore d'aula impari a costruire una presenza social che genera clienti veri, senza dipendere da algoritmi né perdere ore in contenuti che nessuno guarda.",
    ctaPrimary: "Scopri il corso",
    ctaSecondary: "Sconto esclusivo dal 50%",

    variantB: {
      hookHeadline: "I tuoi social piacciono ma non vendono?",
      hookHeadlineAccent: "Cambia metodo.",
      ctaPrimary: "Scopri il corso",
    },

    painsTitle: "Il problema di chi fa social 'a naso'",
    pains: [
      "Pubblichi con costanza ma i follower non crescono e soprattutto non comprano.",
      "Non sai se conviene puntare su Instagram, TikTok, LinkedIn o Facebook per il TUO business.",
      "Copi i format degli altri ma non funzionano — perché non hai una strategia dietro.",
    ],

    solutionTitle: "Il metodo per social che convertono",
    solutionText:
      "Un percorso in aula di 9 ore per progettare una presenza social strategica: dalla scelta dei canali giusti, ai contenuti pilastro che educano il cliente, fino al piano editoriale che ti fa risparmiare tempo e porta risultati misurabili.",

    learnTitle: "Cosa imparerai in aula",
    learnItems: [
      "Come scegliere i social giusti per il TUO business (non tutti servono a tutti)",
      "La strategia contenuti in 3 livelli: attrarre, educare, convertire",
      "Piano editoriale settimanale replicabile (con template pronti)",
      "Copywriting per social: come scrivere post che fanno agire",
      "Formati vincenti nel 2026: Reel, Story, Carosello, Live",
      "Community management: rispondere in modo strategico per aumentare fiducia",
      "Metriche vere vs vanity metrics: cosa monitorare davvero",
      "Come integrare i social con sito, email e ads",
    ],

    targetTitle: "A chi è dedicato",
    targetItems: [
      "Imprenditori PMI e liberi professionisti che vogliono i social come canale di vendita",
      "Chi gestisce i social internamente e vuole finalmente farli funzionare",
      "Chi vuole valutare/coordinare un social media manager esterno",
    ],

    faqs: [
      { q: "Copre tutti i social?", a: "Sì: Instagram, TikTok, Facebook, LinkedIn. Ti insegneremo il metodo, non la tecnica di un singolo social." },
      { q: "Servono competenze grafiche?", a: "No. Vedremo tool gratuiti (Canva, CapCut) per creare contenuti pro senza essere designer." },
      { q: "Include contenuti pronti?", a: "Sì: template Canva, prompt per generare copy con AI, calendario editoriale replicabile." },
      { q: "Dove si svolge?", a: "In presenza al Campus Montacchiello di Pisa. Pausa pranzo conviviale inclusa." },
      { q: "C'è una garanzia?", a: "Sì. Soddisfatti o rimborsati fino alle 13:00 del giorno del corso." },
    ],
  },

  // ============================================================
  // 3. META ADS ADVANCED (FBA)
  // ============================================================
  fba: {
    slug: "fba",
    courseSlug: "facebook-advanced",
    courseName: "Meta Ads Advanced – Campagne professionali",
    price: 260,
    originalPrice: 520,
    hours: "7 ore in aula",
    heroImage: "/location/exterior.jpg",
    heroLabel: "Corso in presenza · Pisa",

    hookHeadline: "Smetti di buttare soldi in ads.",
    hookHeadlineAccent: "Impara a farli fruttare.",
    hookSubtitle:
      "Il corso che ti insegna a strutturare campagne Meta professionali con audience, creativity e KPI ottimizzati — non le pubblicità 'boost post' che bruciano budget.",
    ctaPrimary: "Scopri il corso",
    ctaSecondary: "Sconto esclusivo dal 50%",

    variantB: {
      hookHeadline: "Meta Ads ti sembra un labirinto?",
      hookHeadlineAccent: "Esci con un ROI.",
      ctaPrimary: "Scopri il corso",
    },

    painsTitle: "Il problema con Meta Ads oggi",
    pains: [
      "Fai boost dei post ma ottieni solo like — zero clienti reali.",
      "Hai provato Ads Manager ma la struttura ti sembra un labirinto, e chiudi tutto in perdita.",
      "Paghi un consulente ma non sai valutare se sta lavorando bene o solo bruciando il tuo budget.",
    ],

    solutionTitle: "Il metodo per campagne Meta che generano ROI",
    solutionText:
      "In 7 ore d'aula impari a strutturare campagne Meta come un professionista: obiettivi corretti, audience segmentate, creativity testabili, KPI da monitorare, budget scalabile. Con l'aggiornamento 2026 su Advantage+, iOS 14.5+, Conversions API.",

    learnTitle: "Cosa imparerai in aula",
    learnItems: [
      "Architettura campagne: Sales / Lead / Awareness — quando usarle davvero",
      "Struttura Adset ottimale con Advantage+ audience",
      "Creativity strategy: come produrre 3-5 ad che convertono senza budget produttivo",
      "Setup Pixel + Conversions API per tracking preciso (post iOS 14.5+)",
      "Retargeting funnel: LAL, Custom Audiences, esclusioni",
      "Budget & scaling: quando aumentare, quando killare, quando resettare",
      "KPI reali: CPM, CTR, CPL, CAC, ROAS — cosa monitorare davvero",
      "Case study: campagne reali con budget €10-€1000/gg dei nostri clienti",
    ],

    targetTitle: "A chi è dedicato",
    targetItems: [
      "Imprenditori che vogliono gestire Meta Ads in autonomia con metodo",
      "Chi ha già provato ads ma non ottiene ROI e vuole capirne il perché",
      "Marketer/agenzie junior che vogliono strutturare campagne professionali",
    ],

    faqs: [
      { q: "Serve avere già un budget ads?", a: "No, imparerai il metodo. Ma per applicare consigliamo minimo €300/mese di test iniziale." },
      { q: "Copre anche Instagram Ads?", a: "Sì. Instagram è dentro Meta Ads Manager, quindi lo copriamo insieme a Facebook." },
      { q: "Include tool o software?", a: "Ti insegneremo Ads Manager (gratis) e tool di analisi (alcuni free, alcuni premium opzionali)." },
      { q: "Dove si svolge?", a: "In presenza al Campus Montacchiello di Pisa. Pausa pranzo conviviale inclusa." },
      { q: "C'è una garanzia?", a: "Sì. Soddisfatti o rimborsati fino alle 13:00 del giorno del corso." },
    ],
  },

  // ============================================================
  // 4. CUSTOMER LOYALTY (CL)
  // ============================================================
  cl: {
    slug: "cl",
    courseSlug: "customer-loyalty",
    courseName: "Data-Driven Loyalty & One-Time Offer",
    price: 260,
    originalPrice: 520,
    hours: "5 ore in aula",
    heroImage: "/location/interior-1.webp",
    heroLabel: "Corso in presenza · Pisa",

    hookHeadline: "I tuoi clienti valgono 10x di più.",
    hookHeadlineAccent: "Se sai come farli tornare.",
    hookSubtitle:
      "Il corso che ti insegna a costruire un sistema automatico di fidelizzazione e up-sell — così ogni cliente acquisito genera 3-10 volte il suo primo acquisto negli anni successivi.",
    ctaPrimary: "Scopri il corso",
    ctaSecondary: "Sconto esclusivo dal 50%",

    variantB: {
      hookHeadline: "Acquisisci clienti e poi li dimentichi?",
      hookHeadlineAccent: "Stai lasciando soldi sul tavolo.",
      ctaPrimary: "Scopri il corso",
    },

    painsTitle: "Perché stai perdendo soldi (senza saperlo)",
    pains: [
      "Investi tanto per acquisire nuovi clienti, ma quelli che hai già li lasci scappare senza follow-up.",
      "Non hai un sistema di email/messaggi automatici che parla ai clienti dopo il primo acquisto.",
      "Le tue vendite dipendono dall'acquisizione — ogni mese ricominci da zero e non hai una base fedele.",
    ],

    solutionTitle: "Il metodo Data-Driven Loyalty",
    solutionText:
      "In 5 ore d'aula costruisci il tuo sistema di fidelizzazione automatizzato: dalla segmentazione dei clienti alla One-Time Offer post-vendita, dalle email automatiche di follow-up alle strategie di up-sell/cross-sell che aumentano il Customer Lifetime Value.",

    learnTitle: "Cosa imparerai in aula",
    learnItems: [
      "Calcolare il vero Customer Lifetime Value dei tuoi clienti",
      "Segmentazione dati: clienti alto/medio/basso valore",
      "One-Time Offer (OTO): la strategia post-vendita che raddoppia il ricarico",
      "Email automation per fidelizzazione (setup su piattaforme no-code)",
      "Up-sell e cross-sell: quando proporli e come",
      "Programmi fedeltà semplici che funzionano davvero",
      "Reattivazione clienti dormienti: sequenze che riportano acquisti",
      "KPI da monitorare: retention rate, repeat purchase, CLV",
    ],

    targetTitle: "A chi è dedicato",
    targetItems: [
      "E-commerce e attività con clienti ricorrenti (retail, servizi, wellness)",
      "Liberi professionisti che vogliono clienti fedeli (non solo nuovi)",
      "Chi ha un buon primo acquisto ma poi 'sparisce' senza follow-up",
    ],

    faqs: [
      { q: "Serve un CRM già impostato?", a: "No. Ti insegneremo tool no-code (anche gratuiti) per partire da zero." },
      { q: "Vale anche per servizi/consulenza?", a: "Assolutamente sì. Il metodo si applica a qualunque attività B2C e B2B." },
      { q: "Serve avere già molti clienti?", a: "No. Il metodo è utile sia per chi ha 10 clienti che per chi ne ha 10.000." },
      { q: "Dove si svolge?", a: "In presenza al Campus Montacchiello di Pisa. Pausa pranzo conviviale inclusa." },
      { q: "C'è una garanzia?", a: "Sì. Soddisfatti o rimborsati fino alle 13:00 del giorno del corso." },
    ],
  },

  // ============================================================
  // 5. AGENTI AI (AI)
  // ============================================================
  ai: {
    slug: "ai",
    courseSlug: "agenti-ai",
    courseName: "Agenti AI in Azione",
    price: 260,
    originalPrice: 520,
    hours: "5 ore in aula",
    heroImage: "/location/exterior.jpg",
    heroLabel: "Corso in presenza · Pisa",

    hookHeadline: "Non usare l'AI. Metti l'AI a lavorare.",
    hookHeadlineAccent: "Per te.",
    hookSubtitle:
      "Il corso pratico per costruire agenti AI che automatizzano davvero il tuo lavoro: rispondono ai clienti, generano contenuti, gestiscono email, prenotano appuntamenti — mentre tu ti dedichi al business.",
    ctaPrimary: "Scopri il corso",
    ctaSecondary: "Sconto esclusivo dal 50%",

    variantB: {
      hookHeadline: "Usi ChatGPT ma perdi ancora ore?",
      hookHeadlineAccent: "Costruisci veri agenti AI.",
      ctaPrimary: "Scopri il corso",
    },

    painsTitle: "Il problema di chi 'usa ChatGPT'",
    pains: [
      "Chiedi cose a ChatGPT ma perdi comunque ore per contenuti, email, follow-up quotidiani.",
      "Hai sentito parlare di 'agenti AI' e 'automazioni' ma ti sembra roba da tecnici — non fa per te.",
      "I tuoi competitor stanno risparmiando 20+ ore/settimana con AI, e tu resti indietro senza saperlo.",
    ],

    solutionTitle: "Il metodo Agenti AI in Azione",
    solutionText:
      "In 5 ore d'aula costruisci concretamente 3 agenti AI operativi per la tua attività: uno per contenuti, uno per assistenza clienti, uno per automazioni interne. Con Make, ChatGPT, Claude e strumenti no-code che chiunque può usare — nessuna programmazione richiesta.",

    learnTitle: "Cosa imparerai in aula",
    learnItems: [
      "Cos'è davvero un agente AI (e cosa non è: sfatiamo il marketing hype)",
      "3 casi d'uso ad alto impatto per il tuo business (contenuti, clienti, ops)",
      "Prompt engineering avanzato: come far fare all'AI esattamente quello che vuoi",
      "Automazioni con Make: connettere WhatsApp, Gmail, Sheets, ChatGPT",
      "Costruire un chatbot AI per il tuo sito che qualifica lead in autonomia",
      "Content generation automation: brief → post/email/copy pronti",
      "Ethics & privacy AI: cosa NON dare in pasto ai modelli",
      "Come misurare il ROI dell'AI nella tua attività",
    ],

    targetTitle: "A chi è dedicato",
    targetItems: [
      "Imprenditori PMI che vogliono ridurre ore di lavoro manuale con AI",
      "Liberi professionisti che vogliono scalare senza assumere",
      "Chi ha già provato ChatGPT ma vuole automatizzare (non solo chattare)",
    ],

    faqs: [
      { q: "Serve saper programmare?", a: "Assolutamente no. Useremo solo strumenti no-code (Make, ChatGPT, Claude, tool web)." },
      { q: "Vanno pagati abbonamenti?", a: "Vedremo sia opzioni gratuite che a pagamento. La maggior parte parte da €10-30/mese e si ripaga in poche ore risparmiate." },
      { q: "Include agenti pre-costruiti?", a: "Sì: ti forniamo 3 template di agenti AI da personalizzare per la tua attività." },
      { q: "Dove si svolge?", a: "In presenza al Campus Montacchiello di Pisa. Pausa pranzo conviviale inclusa." },
      { q: "C'è una garanzia?", a: "Sì. Soddisfatti o rimborsati fino alle 13:00 del giorno del corso." },
    ],
  },
};

// Shared bonus block (same across all landings)
export const LANDING_BONUS = [
  {
    title: "Workbook operativo",
    text: "Un manuale di 40+ pagine con esercizi, template e checklist da applicare subito nella tua attività.",
  },
  {
    title: "Community privata",
    text: "Accesso al gruppo dei corsisti per confrontarti con altri imprenditori e con i formatori.",
  },
  {
    title: "Coaching di gruppo (mensile)",
    text: "1 sessione mensile di coaching di gruppo per i primi 3 mesi post-corso, per applicare quello che hai imparato.",
  },
  {
    title: "Aggiornamenti perpetui",
    text: "Ricevi gli aggiornamenti dei materiali del corso per sempre, senza costi aggiuntivi.",
  },
];
